export function getProMatchlistQueryString(
  championId: string | number | null,
  role: string | null,
) {
  const queryParams = new URLSearchParams();
  if (role) queryParams.set("role", role === "BOT" ? "BOTTOM" : role);
  if (championId) queryParams.set("champion_id", `${championId}`);
  return queryParams.toString();
}
